import toast from "react-hot-toast";
import  {client} from "@/app/ApolloClient";
import {gql} from "@apollo/client";


var query = gql`
  query GetAssetTypes($organizationId: UUID!) {
    assetTypes(organizationId: $organizationId) {
      id
      name
      available_for_leasing
      description
      enable_deposit
      enable_one_time_payment
      enable_rent
      published
      regenerate_contracts_on_move
      require_vehicle
    }
  }
`;



export function apiGetAssetTypes(organizationId) {
    return new Promise(async (resolve, reject) => {
        if(!organizationId) reject("organizationId is required");

        client
            .query({
                query: query,
                variables: {organizationId},
                errorPolicy: "ignore",
                fetchPolicy: "network-only"
            })
            .then((result) => {
                resolve(result.data.assetTypes);
            })
            .catch((err) => {
                toast.error("Api Error, Unable to get asset types");
                reject(err); // R
            })
    });
}
